import { CELL_TYPE } from "./defaults";
export const changeCell = (puzzle, newCell, rowIdx, cellIdx) => {
    return puzzle.map((_row, _rowIdx) => {
        return _row.map((_cell, _cellIdx) => {
            if (rowIdx === _rowIdx && cellIdx === _cellIdx) {
                return {
                    ..._cell,
                    ...newCell
                };
            }
            else {
                return _cell;
            }
            ;
        });
    });
};
export const clearPuzzle = (puzzle) => {
    return puzzle.map(row => {
        return row.map(cell => {
            if (cell.type !== CELL_TYPE.SET) {
                return {
                    ...cell,
                    type: CELL_TYPE.DEFAULT,
                    value: 0,
                    valid: true
                };
            }
            else {
                return cell;
            }
        });
    });
};
export const checkPuzzle = (puzzle, solution) => {
    if (puzzle.length === 0 || solution.length === 0)
        return false;
    for (let i = 0; i < puzzle.length; i++) {
        for (let j = 0; j < puzzle[i].length; j++) {
            if (puzzle[i][j].value === 0 || puzzle[i][j].value !== solution[i][j]) {
                return false;
            }
        }
    }
    return true;
};
export const showCellState = (puzzle, solution) => {
    if (puzzle.length === 0 || solution.length === 0)
        return null;
    const newPuzzle = puzzle;
    for (let i = 0; i < puzzle.length; i++) {
        for (let j = 0; j < puzzle[i].length; j++) {
            if (puzzle[i][j].value !== solution[i][j]) {
                newPuzzle[i][j].showState = true;
            }
        }
    }
    return newPuzzle;
};
export const getRandomNumber = (min, max) => {
    return Math.floor(Math.random() * (max - min + 1) + min);
};
export const emptyCellsCount = (puzzle) => {
    let count = 0;
    puzzle.map(row => {
        row.map(cell => {
            if (cell.value === 0)
                count++;
        });
    });
    return count;
};
export const getHint = (puzzle, solution) => {
    if (puzzle.length === 0 || emptyCellsCount(puzzle) === 0)
        return puzzle;
    let randomRowIdx = 0, randomCellIdx = 0;
    do {
        randomRowIdx = getRandomNumber(0, 8);
        randomCellIdx = getRandomNumber(0, 8);
    } while (puzzle[randomRowIdx][randomCellIdx].value !== 0);
    let hintedPuzzle = changeCell(puzzle, {
        type: CELL_TYPE.HINT,
        value: solution[randomRowIdx][randomCellIdx]
    }, randomRowIdx, randomCellIdx);
    return hintedPuzzle;
};
export const getTranslatedString = (key) => {
    // @ts-ignore
    return sudokuVariables[key] || '';
};
export const checkFilled = (puzzle) => {
    if (puzzle.length === 0)
        return false;
    for (let i = 0; i < puzzle.length; i++) {
        for (let j = 0; j < puzzle[i].length; j++) {
            if (puzzle[i][j].value === 0) {
                return false;
            }
        }
    }
    return true;
};
